import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const FilterIconContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: ${tokens.radius.control};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  color: ${tokens.text.primary};
  cursor: pointer;
  position: relative;
  border: 1px solid ${tokens.border.hairline};
  background-color: ${tokens.surface.glass};
  backdrop-filter: blur(${tokens.blur});

  svg {
    fill: ${tokens.accent.base};
  }
`

export const FiltersContainer = styled.div<{ visibleFilterOverflow?: boolean }>`
  position: absolute;
  padding: 1rem;
  top: 4rem;
  left: 0;
  width: 28.125rem;
  height: fit-content;
  overflow: ${(props) => (props.visibleFilterOverflow ? 'visible' : 'auto')};
  z-index: 999999;
  color: ${tokens.text.primary};
  background-color: ${tokens.surface.raised};
  border: 1px solid ${tokens.border.hairline};
  border-top: 2px solid ${tokens.accent.base};
  border-radius: ${tokens.radius.card};
  box-shadow: ${tokens.shadow.card};
`

export const FiltersContainerTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: auto;
  padding: 10px;

  p {
    cursor: pointer;
    transition: 0.1s ease-in;
    &:hover {
      color: ${tokens.accent.base};
    }
  }
`

export const SingleFilterTitle = styled.div<ISingleFilterContainer>`
  width: 100%;
  padding: 5px;
  display: flex;
  user-select: none;
  cursor: pointer;
  align-items: center;
  justify-content: flex-start;
  transition: 0.3s ease;

  svg {
    fill: none;
    stroke: ${tokens.text.secondary} !important;
    transform: rotate(${(props) => (props.open ? '0' : '-90')}deg);
    transition: 0.2s ease-in;
    width: 15px;
    margin-right: 5px;
  }
`

interface ISingleFilterContent {
  open: boolean
}

export const SingleFilterContent = styled.div<ISingleFilterContent>`
  transition: 0.1s ease-in;
  overflow: hidden;
  width: 100%;
  height: max-content;
  max-height: ${(props) => (props.open ? 'max-content' : '0px')};
  background-color: transparent;
  cursor: auto;
`

interface ISingleFilterContainer {
  open: boolean
}
export const SingleFilterContainer = styled.div<ISingleFilterContainer>`
  display: flex;
  justify-content: start;
  align-items: center;
  transition: 0.2s ease-in;
  flex-direction: column;
`
export const SearchBox = styled.div`
  width: 100%;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  background-color: ${tokens.surface.inset};
  height: 40px;
  overflow: hidden;
  display: flex;
  align-items: center;

  input {
    width: 90%;
    height: 100%;
    padding: 10px;
    border: none;
    outline: none;
    color: ${tokens.text.primary};
    background-color: transparent;
    flex: 9;
    ::placeholder {
      color: ${tokens.text.muted};
    }
  }

  svg {
    fill: none;
    flex: 1;
    transform: scale(1.2);
  }
`

export const ClearFilterButton = styled.p`
  font-size: 0.75rem;
  background-color: ${tokens.accent.soft};
  color: ${tokens.accent.onDark};
  padding: 5px;
  border-radius: ${tokens.radius.chip};
  transition: 0.1s ease;
  border: 1px solid ${tokens.accent.base};
  &:hover {
    transform: scale(1.01);
  }
`

export const SelectedOption = styled.div`
  padding: 2px;
  font-size: 12px;
  border: 1px solid ${tokens.border.hairline};
  background-color: ${tokens.surface.inset};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.5rem;
  cursor: pointer;
  gap: 0.5rem;
  position: relative;
  svg {
    scale: 0.8;
  }
  border-radius: 5px;

  ::after {
    position: absolute;
    top: 0;
    left: 0;
    content: 'Remove';
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: ${tokens.surface.glass};
    transition: opacity 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
  }

  &:hover::after {
    opacity: 0.9;
  }
`

export const SelectedOptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 15px;
  padding: 10px;
`
